import React, { SVGProps } from "react";

export default function SupX(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99901 10.5651L17.4519 18L17.998 17.4146L10.5655 10.0001L18.0001 2.58529L17.454 2L9.99908 9.43507L2.54602 2L2 2.58536L9.43261 10L2.00007 17.4128L2.54615 17.998L9.99901 10.5651Z"
        fill="currentColor"
      />
    </svg>
  );
}
